export enum Activite {
  Apprenti = "apprenti",
  Autre = "autre",
  BeneficiaireRsa = "beneficiaire_rsa",
  Chomeur = "chomeur",
  Etudiant = "etudiant",
  Inactif = "inactif",
  Independant = "independant",
  Professionnalisation = "professionnalisation",
  Retraite = "retraite",
  Salarie = "salarie",
  ServiceCivique = "service_civique",
  SituationHandicap = "situation_handicap",
  Stagiaire = "stagiaire",
}
